<nb-card>
  <nb-card-header>
    <!-- Title -->
    <div class="title">{{title}} <ngx-how-to-modal *ngIf="!readonly" [helpLabel]='"How To Use Templates."'
      [link]='"https://www.youtube.com/embed/j6AjKewJnlk"'></ngx-how-to-modal></div>
    <div class="actions">
      <!-- Search -->
      <nb-form-field class="search-field">
        <input nbInput #search shape="semi-round" fieldSize="small" class="search" i18n-placeholder="@@SearchThreeDots">
        <nb-icon nbSuffix icon="search-outline" pack="eva"></nb-icon>
      </nb-form-field>
      <!-- Add -->
 
    </div>
  </nb-card-header>

  <nb-card-body>

    <ngx-skeleton-item-list *ngIf="!contentLoaded"></ngx-skeleton-item-list>

    <!-- Data Table -->
    <mat-table *ngIf="contentLoaded" [dataSource]="dataList" matSort [matSortDisableClear]="true" (matSortChange)="onSortChanged($event)">

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Name"> Name </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Name" i18n-data-label="@@Name"> {{row.name}} </mat-cell>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Description"> Description </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Description" i18n-data-label="@@Description">
          {{row.description}}
        </mat-cell>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Actions"> Actions </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Actions" i18n-data-label="@@Actions">
          <div *ngIf="!readonly">
            <button nbButton ghost shape="round" size="small" (click)="onDuplicate(row.id)">
              <img src="/assets/icons/copy-outline.svg" alt="duplicate" class="img-archive" width="24" height="24">
            </button>
            <button nbButton ghost shape="round" size="small" [routerLink]="[editUrl + row.id]">
              <img src="/assets/icons/added_oultine_modify_pencil.svg" alt="edit" class="img-archive" width="24"
                height="24">
            </button>
            <button nbButton ghost shape="round" size="small" (click)="onDelete(row.id)">
              <img src="/assets/icons/trash-2-outline.svg" alt="delete" class="img-archive" width="24" height="24">
            </button>
          </div>
          <div *ngIf="readonly">
            <button nbButton ghost shape="round" size="small" [routerLink]="[editUrl + row.id]">
              <img src="/assets/icons/eye-outline.svg" alt="view" class="img-archive" width="24" height="24">
            </button>
          </div>
        </mat-cell>
      </ng-container>

      
      <!-- Actions -->
      <ng-container matColumnDef="assing">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@Actions" style="justify-content: flex-end;"> Assign </mat-header-cell>
        <mat-cell *matCellDef="let row" data-label="Assign" i18n-data-label="@@Actions" style="justify-content: flex-end;">
          <ngx-assing-plan-client [planId]="row.id" [isMealPlan]="isMealPlan" [isProgramTemplate]="isProgramTemplate" [programTemplate]="row"></ngx-assing-plan-client>
        </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator #paginator [length]="totalCount" [pageSize]="10" (page)="loadDataList(true)"
      [class.hidden]="totalCount === 0">
    </mat-paginator>

    <div *ngIf="contentLoaded && totalCount === 0" class="text-center p-4">
      <button nbButton *ngIf="!readonly" size="small"  class="btn-circle btn-xl btn-main"  (click)="onAddTemplate()">
        <nb-icon icon="plus"></nb-icon> <span>Create a new Template</span>
      </button>
    </div>

    <div *ngIf="isMealPlan && readonly">
      <span style="font-size: 8pt; color: gray; margin-left: 15px;">* Public Templates created by <a href="https://www.trainerfriend.com/" target="_blank">TrainerFriend.com</a> nutritionist.</span>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <div style="width: auto; float: right;">
      <button i18n="@@AddNew" nbButton class="btn-circle btn-xl btn-main" (click)="onAddTemplate()">
        Add New
      </button>
    </div>
  </nb-card-footer>

</nb-card>
